import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { videos } from 'src/constants/videos'
export default (props) => (
  <USTemplateDefault
    location={props.location}
    lang="en"
    market="us"
    video={videos.disney_channel.videoUrl}
    title="Watch the Disney Channel with Fubo"
    subtitle="Enjoy DuckTales and more, live and on demand"
    ctaText="Start Watching"
    networkSet="entertainment"
    customNetworks={[
      'nickelodeon',
      'disney',
      'universalkids',
      'disneyjunior',
      'nickjr',
      'disneyxd',
      'nicktoons',
    ]}
  />
)
